import { DateTime } from "luxon";
import { BaseDataGridRequest } from "../base-data-grid.request";

export interface GetPlansRequest extends BaseDataGridRequest {
  planContainerId?: string;
  name?: string | null;
  description?: string | null;
  distance?: number | null;
  duration?: string | null;
  jobsCount?: number | null;
  locationsCount?: number | null;
  planType?: number | null;
  distributionLaneName? : string | null;
  status?: number [] | null;
  isScheduled?: boolean | null;
  schedule?: DateTime | null;
}
